import { API } from '../../../api';
import { canAccess } from '../../../config';

// Import generic components
import Button from '../../../generic_components/Button/Button';
import { useToast } from '../../../generic_components/Toast/Toast';


const UploadSitePlan = (
{
    hwid,
    loading,
    setLoading,
    message,
    setMessage,
    fileToUpload,
    setFileToUpload,
    isUploaded,
    setIsUploaded,
    previewLocal,
    setPreviewLocal,
    previewUploaded,
    setPreviewUploaded,
    setStep,
    handleGoToCameraPlacement,
    step,
    canvasRef,
    canvascamImagesRef,
    userBusinessRole
}) => {

    const toast = useToast();

    // Choose file and upload it
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        
        // Check if hwid is there
        if (!hwid) {
            alert(`HWID is required.`);
            e.target.value=null;
            setPreviewLocal(null);
            return
        }
        // Check if file is selected
        if (!file) {
            e.target.value=null;
            return
        }
        // Check if the uploaded file is < 2MB
        if ((!file.type.includes('jpeg') && !file.type.includes('png')) || (file.size / (1024 * 1024)) > 2) { // convert to MB from bytes
            alert(`Please upload a jpeg/png file which does not exceed 2MB.`);
            e.target.value=null; // Reset the input value to null to prevent the case when user tries to upload the >2MB image for the second time and it does not fire the alert. 
            return;
        }
        // File is valid, then render the selected image
        setIsUploaded(false); // User choose a file but yet to upload

        const imageURL = URL.createObjectURL(file);
        setFileToUpload(file);
        setPreviewLocal(imageURL); // set image url to previewLocal
    }

    // Upload file to S3 bucket and db
    const handleFileUpload = async () => {
        // Check if hwid is there
        if (!hwid) {
            alert(`HWID is required.`);
            return
        }
        // Check if file is uploaded
        if (!fileToUpload) {
            alert(`An image file is required`);
            return
        }
        // Check if the uploaded file is < 2MB
        if ((!fileToUpload.type.includes('jpeg') && !fileToUpload.type.includes('png')) || (fileToUpload.size / (1024 * 1024)) > 2) { // convert to MB from bytes
            alert(`Please upload a jpeg/png file which does not exceed 2MB`);
            return;
        }

        // Upload the image to S3 bucket using upload route
        const formData = new FormData();
        formData.append('image', fileToUpload, fileToUpload.name);
        formData.append('hwid', hwid);

        let message = "";

        try {
            setLoading(true);
            setMessage('Uploading image...');

            // Upload the image to S3 bucket
            const res = await API.post('/devices-sites/upload', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            if (res.data.success) {
                setMessage('✅ Image uploaded successfully! Proceed to the next step to place your cameras.');
                message = 
                (<div className="success-text-siteplan">
                    <span>Image uploaded successfully! Proceed to the next step to place your cameras.</span>
                </div>)
                toast.success(message, 
                {
                    theme: "colored",
                    autoClose: 6000,
                })
                // Keep local preview showing
                // Do NOT update previewUploaded immediately to avoid cache issues
                setFileToUpload(null);
                setPreviewLocal(null); // test for now. delete later
                setIsUploaded(true);
            } 
            else {
                message = (
                    <div className="failure-text-siteplan">
                        <span>Image uploaded unsuccessfully!</span>
                    </div>
                )
                toast.error(message,
                {
                    theme: "colored",
                    autoClose: 6000,
                })
                setMessage('Upload failed.');
                setIsUploaded(false);
            }
        } 
        
        catch (err) {
            console.error('Upload error:', err);
            message = (
                <div className="failure-text-siteplan">
                    <span>Image uploaded unsuccessfully. {err}</span>
                </div>
            )
            toast.error(message, 
            {
                theme: "colored",
                autoClose: 6000,
            })
            setMessage('Upload failed.');
            setIsUploaded(false);
        } finally {
            setLoading(false);
        }
    };

    return (

        <div className="upload-file-container">
            <div className="progress-steps">
                <div className="step active">
                    <div className="step-number">1</div>
                    <span>Upload Site Plan</span>
                </div>
                <div className="step incompleted">
                    <div className="step-number">2</div>
                    <span>Place Cameras</span>
                </div>
                <div className="step incompleted">
                    <div className="step-number">3</div>
                    <span>Save Configuration</span>
                </div>
            </div>

            <div className="upload-container">
                <div className="upload-area" id="uploadArea">
                    <i className="fa-solid fa-cloud-arrow-up fa-3x" style={{color: '#ffffff', marginBottom: '1rem'}}></i>
                    <h2 className="upload-title">Upload Your Site Plan</h2>
                    <p className="upload-subtitle">Choose your site plan to preview and upload it when you're ready!</p>
                    <p className="formats-accepted">JPEG, JPG, PNG &lt; 2MB</p>
                    <div className="browse-upload-buttons">
                        <label className={`choose-file-button ${
                            !canAccess("site-map-upload", userBusinessRole) ? "label-disabled" : ""
                        }`}>
                            <input
                                type="file"
                                accept="image/jpeg,image/png"
                                id="file" name="file" 
                                onChange={handleFileChange}
                                className="browse-input"
                                disabled = {!canAccess("site-map-upload", userBusinessRole)}
                            />
                            Browse File
                        </label>
                        <Button size='sm' className="upload-button" onClick={handleFileUpload} disabled = {!canAccess("site-map-upload", userBusinessRole)}>
                            {loading ? 'Uploading...' : 'Upload Image'}
                        </Button>
                    </div>
                </div>
            </div>
            
            {fileToUpload && 
                <>
                <h4 className="image-preview-title">Image Preview</h4>
                <div className="image-preview-container">
                    <img
                    src={previewLocal}
                    alt="Preview"
                    className="image-preview"
                    onLoad={() => URL.revokeObjectURL(fileToUpload)} // cleanup
                    />
                </div>
                </>
            }

            <div className="clearfix">
                <button className="next-button" id="nextButton" disabled={!isUploaded?true:false} onClick={handleGoToCameraPlacement}>
                    Next <i className="fa-solid fa-caret-right"></i>
                </button>
            </div>
        </div>

    );
}

export default UploadSitePlan;